export const SET_SELECTED = 'SET_SELECTED'

export const setSelectedFactory = (key) => {
  return (value) => {
    return {
      type: SET_SELECTED,
      state: {
        [key]: value || null,
      },
    }
  }
}

export const setSelected = (state) => {
  return {
    type: SET_SELECTED,
    state,
  }
}
export const setSelectedTimelineId = setSelectedFactory('timelineId')
